import * as IMG from '@Utils/Images';

export default function Component() {
  return (
    <section className="promotion-section">
      <div className="container">
        <div className="row m-0 justify-content-between align-items-center">
          <div className="col-lg-6 pe-0 mb-lg-0 mb-5">
            <img
              src={IMG.PROMOTION}
              alt="promotion"
              width="100%"
            />
          </div>
          <div className="col-lg-5 ps-0">
            <div className="subtitle">Promotion</div>
            <h1 className="title fw-bold lh-base">
              The{' '}
              <span className="bg-primary2 text-white">Ultimate Clothing</span>{' '}
              To See The World In
            </h1>
            <h6 className="fw-medium mt-4 mb-5 text-secondary lh-base">
              Anyone can get dressed up and glamorious, but it is how people
              dress in their days off that are the most intriguing
            </h6>
            <button className="btn p-0">
              <h5 className="m-0 fw-bold lh-lg">
                Find Out More{' '}
                <i className="fa-solid fa-arrow-trend-up ms-2"></i>
              </h5>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};